exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".truncate {\r\n  white-space: nowrap;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n}\r\n\r\n.header-seccion-form {\r\n\tbackground-color: #d2d0d0;\t\r\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// D:/GIT/F300/V4/ng_formulario300v4/src/app/components/declaracion-sugerida/dialogo-valores-declaracion-sugerida/dialogo-val-decla-sugerida.component.css
// module id = ../../../../../src/app/components/declaracion-sugerida/dialogo-valores-declaracion-sugerida/dialogo-val-decla-sugerida.component.css
// module chunks = main